import LinkHelper from '@wetransfer/transfer/component/navigation/helpers/link';
import Links from '@wetransfer/transfer/component/navigation/links';
import {
  FF_NAV_SIGN_UP_EXPERIMENT,
  FF_REFERRAL_PROGRAM,
} from '@wetransfer/transfer/constant/experiments';
import {
  userHasPaidTier,
  userHasFreeTier,
  userHasPremium2022Tier,
  userHasPro2022Tier,
  userHasPlusTier,
} from '@wetransfer/transfer/helper/user';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

const accountUser = (navigation, user) => {
  // Paid users

  if (userHasPaidTier(user)) {
    if (userHasPremium2022Tier(user)) {
      navigation = LinkHelper.attachFeaturePortalsLink(navigation);
    }

    if (userHasPro2022Tier(user) || userHasPlusTier(user)) {
      navigation = LinkHelper.attachFeaturePortalsLink(navigation);
      navigation = LinkHelper.attachUpgradeAccountLink(navigation, user);
    }
  }

  if (userHasPaidTier(user) && getVariant(FF_REFERRAL_PROGRAM) === 'on') {
    navigation = LinkHelper.attachReferralLink(navigation);
  }

  // Free
  if (userHasFreeTier(user)) {
    navigation = LinkHelper.attachFeaturePortalsLink(navigation);
    navigation = LinkHelper.attachUpgradeAccountLink(navigation, user);
  }

  return navigation;
};

const anonymousUser = (navigation, user) => {
  if (getVariant(FF_NAV_SIGN_UP_EXPERIMENT) === 'variant-c') {
    navigation = LinkHelper.attachFeaturesExperimentLink(navigation);
  }

  navigation = LinkHelper.attachFeaturesMenu(navigation, user);
  navigation = LinkHelper.attachSignupLink(navigation);

  return navigation;
};

export default {
  create: (user) => {
    let navigation;

    navigation = user.loggedIn
      ? {
          transfers: Links.transfersItem,
          contacts: Links.contactsItem,
          branding: Links.brandingItem,
        }
      : {
          pricing: Links.pricingItem,
          about: Links.aboutItem,
          help: Links.helpItem,
          account: Links.loginItem,
        };

    navigation = user.loggedIn
      ? accountUser(navigation, user)
      : anonymousUser(navigation, user);

    return Object.values(navigation);
  },
};
